import { render, staticRenderFns } from "./AlarmConfiguration.vue?vue&type=template&id=32488318&scoped=true&"
import script from "./AlarmConfiguration.vue?vue&type=script&lang=js&"
export * from "./AlarmConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./AlarmConfiguration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AlarmConfiguration.vue?vue&type=style&index=1&id=32488318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32488318",
  null
  
)

export default component.exports